import React from 'react'
import PropTypes from 'prop-types'
import {
	PieChart,
	Pie,
	Cell,
	Tooltip,
	ResponsiveContainer,
	Legend,
} from 'recharts'
import ChartWrapper from './chartWrapper'
import PlaceholderChart from './placeholderChart'

const DEFAULT_COLORS = ['#3498db', '#2ecc71', '#f1c40f', '#e74c3c', '#9b59b6']

const UniversalPieChart = ({
	data,
	title,
	colors = DEFAULT_COLORS,
	nameKey = 'name',
	dataKey = 'value',
	height = 300,
	emptyMessage = 'Nenhum dado encontrado.',
}) => {
	if (!data || data.length === 0 || data.every((item) => item[dataKey] === 0)) {
		return <PlaceholderChart title={title} message={emptyMessage} />
	}

	return (
		<ChartWrapper title={title}>
			<ResponsiveContainer width="100%" height={height}>
				<PieChart>
					<Pie
						data={data}
						cx="50%"
						cy="50%"
						labelLine={false}
						label={({ name, percent }) =>
							`${name}: ${(percent * 100).toFixed(0)}%`
						}
						outerRadius={80}
						fill="#8884d8"
						dataKey={dataKey}
						nameKey={nameKey}>
						{data.map((entry, index) => (
							<Cell
								key={`cell-${index}`}
								fill={
									Array.isArray(colors)
										? colors[index % colors.length]
										: colors[entry[nameKey]] || '#3498db'
								}
							/>
						))}
					</Pie>
					<Tooltip />
					<Legend />
				</PieChart>
			</ResponsiveContainer>
		</ChartWrapper>
	)
}

UniversalPieChart.propTypes = {
	data: PropTypes.array,
	title: PropTypes.string.isRequired,
	colors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	nameKey: PropTypes.string,
	dataKey: PropTypes.string,
	height: PropTypes.number,
	emptyMessage: PropTypes.string,
}

export default UniversalPieChart
